import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setDoc, doc, getDoc } from 'firebase/firestore/lite';
import {db} from './../firebase';
import FileUploader from './../FileUploader';

export const ProfileEdit = () => {
      const [name, setName] = useState('');
      const [mainInfo, setMainInfo] = useState('');
      const [imageUrl, setImageUrl] = useState('');
      const [pdfUrl, setPdfUrl] = useState('');
      const [error] = useState('');
      const [message, setMessage] = useState('');
      const navigate = useNavigate(); // Hook for navigation

      const fetchProfile = async () => {
        const docSnap = await getDoc(doc(db, "profile", "4fTlePDeB9cdfxkw2okC"));
        const profile = docSnap.data();
        setName(profile.name);
        setMainInfo(profile.main_info);
        setImageUrl(profile.image_url);
        setPdfUrl(profile.pdf_url);
      }

      const handleSaveProfile = async () => {
        await setDoc(doc(db, "profile", "4fTlePDeB9cdfxkw2okC") , {
          name: name,
          main_info: mainInfo,
          image_url: imageUrl,
          pdf_url: pdfUrl
        });
        setMessage('Se guardo la información');
        setTimeout( ()=> setMessage(''), 5000 );
      }

      const goToDashboard = async () => {
        navigate('/dashboard');
      };

      useEffect(()=>{
        fetchProfile();
      }, [])

      return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100">
          <div className="col-sm-12 p-4">
            <div className="card shadow p-4">
              <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                <button className="btn btn-danger" onClick={goToDashboard} >Regresar</button><h3 className="mb-0">Perfil</h3>
              </div>
                  {error && <p style={{ color: 'red' }}>{error}</p>}
                  {message && <p style={{ color: 'green' }}>{message}</p>}
                  <form>
                      <div className="mb-3">
                          <label className="form-label">Información Principal</label>
                          <textarea
                            className="form-control" id="main_info" aria-describedby="emailHelp"
                            type="text"
                            placeholder="Ingresa tu Información"
                            onChange={(e) => setMainInfo(e.target.value)}
                            required
                            rows="10"
                            value={mainInfo}
                          ></textarea>
                      </div>
                      <div className="mb-3">
                        <FileUploader imageMaxWidth={'20em'} url={imageUrl} onUpload={(file)=>{
                            setImageUrl(file);
                          }}/>
                      </div>
                      <div className="mb-3">
                        <FileUploader isPdf={true} url={pdfUrl} onUpload={(file)=>{
                            setPdfUrl(file);
                          }}/>
                      </div>
                      <button type="button" onClick={handleSaveProfile} className="btn btn-primary w-100">Guardar</button>
                  </form>
              </div>
          </div>
      </div>
      );
    };